import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Griddle from 'griddle-react';

import * as ObjectHelper from 'js/common/object_helper';

import 'scss/campaign_execution_flow/crm_query_results_list.scss';
import {getRowDataForRowComponent} from 'js/common/griddle_column_helper';

const noProfilePicture = require('images/logo.png');

const platformProfileLinks = {
    instagram: 'https://www.instagram.com/',
    youtube: 'https://www.youtube.com/channel/',
    twitter: 'https://twitter.com/'
};

const CrmQueryResultsRow = ({data, platform, urls}) => {
    const {publisherLeadDetailsUrl} = urls;
    const {id: leadId} = data;

    const socialAccount = ObjectHelper.propOr({}, platform, data);
    const {bio, recent_media = []} = socialAccount;
    const recentMedia = R.map(recentMedia => {
        const backgroundStyle = {
            backgroundImage: `url(${recentMedia.image_url})`
        };

        return (
            <div
                className="creator-recent-content"
                style={backgroundStyle}
                key={recentMedia.image_url}
            />
        );
    }, R.take(6, recent_media));

    let leadLink = publisherLeadDetailsUrl.replace('__ID__', leadId);
    if (socialAccount) {
        switch (platform) {
            case 'instagram':
                leadLink = `${platformProfileLinks[platform]}${socialAccount.social_handle}`;
                break;
            case 'youtube':
                leadLink = `${platformProfileLinks[platform]}${socialAccount.social_id}`;
                break;
            case 'twitter':
                leadLink = `${platformProfileLinks[platform]}${socialAccount.social_handle}`;
                break;
            default:
                leadLink = publisherLeadDetailsUrl.replace('__ID__', leadId);
        }
    }

    let profilePictureUrl = noProfilePicture;
    if (socialAccount.profile_image_url) {
        profilePictureUrl = socialAccount.profile_image_url;
    }
    const profilePictureStyle = {
        backgroundImage: `url(${profilePictureUrl})`
    };

    return (
        <div className="crm-results-list-row">
            <div className="creator-metrics">
                <div className="creator-profile-picture" style={profilePictureStyle} />
                <div className="creator-social-account">
                    <a
                        className="creator-lead-link"
                        href={leadLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {socialAccount.social_handle}
                    </a>
                    <div className="creator-lead-bio">{bio}</div>
                    <table className="creator-metrics-table">
                        <thead>
                            <tr>
                                <th>Avg Reach</th>
                                <th>Avg Eng</th>
                                <th>Avg Eng Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{socialAccount.followed_by}</td>
                                <td>
                                    {socialAccount.avg_engagements_per_post
                                        ? socialAccount.avg_engagements_per_post.toFixed(2)
                                        : 'N/A'}
                                </td>
                                <td>
                                    {`${
                                        socialAccount.avg_engagement_rate
                                            ? `${(socialAccount.avg_engagement_rate * 100).toFixed(
                                                  2
                                              )}%`
                                            : 'N/A'
                                    }`}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="creator-content">{recentMedia}</div>
        </div>
    );
};

const CrmQueryResultsList = props => {
    const {results, urls, campaign_platform} = props;
    return (
        <div className="crm-query-results-list">
            <Griddle
                results={results}
                columns={['id']}
                columnMetadata={[
                    {
                        columnName: 'id',
                        displayName: 'Lead ID'
                    }
                ]}
                useCustomRowComponent
                customRowComponent={rowProps => {
                    const rowData = getRowDataForRowComponent(rowProps);
                    return (
                        <CrmQueryResultsRow
                            data={rowData}
                            urls={urls}
                            platform={campaign_platform}
                        />
                    );
                }}
                useGriddleStyles={false}
                showPager={false}
                resultsPerPage={20}
            />
        </div>
    );
};

CrmQueryResultsList.propTypes = {
    campaign_platform: PropTypes.string.isRequired,
    results: PropTypes.array.isRequired,
    urls: PropTypes.object.isRequired
};

export default CrmQueryResultsList;



// WEBPACK FOOTER //
// ./components/campaign_execution_flow/crm_query_results_list.js